const url = "https://api.hypv.ai/ws/2024-03/event_post";

async function getCart() {
  const response = await fetch("/cart.js");
  const cart = await response.json();

  delete cart.note;
  cart.items = cart.items.map((item) => {
    delete item.product_description;
    return item;
  });

  return cart;
}

async function getAnalyticsData() {
  await new Promise((resolve) => setTimeout(resolve, 1000));

  const analytics = window.ShopifyAnalytics;

  if (analytics && analytics.lib) {
    const navigationInfo = analytics?.lib?.navigationInfo;
    const libCopy = JSON.parse(JSON.stringify(analytics?.lib));
    const attributes = libCopy?.trekkie?.defaultAttributes;

    const meta = analytics.meta;
    const page = window.meta.page;
    const product = meta.product;

    return { attributes, navigationInfo, meta, page, product };
  } else {
    console.log("lib is not available yet.");
    return {};
  }
}

async function createBody(options) {
  const q = new URLSearchParams(window.location.search).toString();
  const { cartFetch = true, payload = {} } = options;
  const c = cartFetch ? await getCart() : undefined;

  const data = await getAnalyticsData();

  const { attributes, navigationInfo, meta, page, product } = data;

  return {
    q: q,
    ck: page?.customerId?.toString(),
    u: window.location.href,
    r: document.referrer,
    nt: navigationInfo?.navigationType,
    pt: page?.pageType ?? "unknown",
    rk: page?.resourceId?.toString(),
    sk: attributes?.visitToken,
    vk: attributes?.uniqToken,
    msid: attributes?.microSessionId,
    msc: attributes?.microSessionCount,
    pdt: product
      ? {
          key: product.id.toString(),
          variantKey: meta?.selectedVariantId,
        }
      : undefined,
    c,
    ...payload,
  };
}

async function send(url, body) {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`HTTP error ${response.status}: ${response.statusText}`);
    }

    return response;
  } catch (error) {
    console.error(`Error sending event: ${error.message}`);
    return null;
  }
}

async function sendPageView() {
  const options = { cartFetch: true };
  const body = await createBody({ ...options, payload: { kind: "pageview" } });
  return await send(url, body);
}

(async () => {
  if (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
  ) {
    return;
  }

  await sendPageView();
})();
